import axios from "axios";
import { useEffect, useState } from "react";

export default function SendBulk(props) {
  const { Details } = props;
  // const [emails] = useState([
  //   "a@gmail.com",
  //   "b@gmail.com",
  //   "c@gmail.com"
  // ]);
  const [emails, setEmail] = useState([]);
  // Details.forEach(item => {
  //   emails.push(item.name);
  // });
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [file, setFile] = useState(null);

  const sendAll = async () => {
    const fd = new FormData();
    fd.append("emails", JSON.stringify(emails)); // ARRAY
    fd.append("message", message);
    fd.append("subject", subject);
    fd.append("file", file); // SAME FILE

    await axios.post("https://api.nextgendesigner.com/send-bulk", fd);
    // await axios.post("http://localhost:4000/send-bulk", fd);
    alert(`Total Email Sent, ${emails.length}`);
  };

  useEffect(() => {
    setMessage(localStorage.getItem("EmailMessage"))
    setSubject(localStorage.getItem("EmailSubject"))
    var email = []
    Object.values(Details).forEach(item => {
      email.push(item.Email);
    });
    setEmail(email)
  }, [])
  return (
    <>
      {/* {JSON.stringify(emails)} */}
      {/* <div>

        <textarea
          placeholder="Subject"
          onChange={e => setSubject(e.target.value)}
        />
      </div>
      <div>

        <textarea
          placeholder="Message"
          onChange={e => setMessage(e.target.value)}
        />
      </div>
      <div>

        <input type="file" onChange={e => setFile(e.target.files[0])} />
      </div>
      <button onClick={sendAll}>Send to All</button> */}
      <div className="row" >
        {/* <div className="col-1" /> */}
        <div className="form-view mb-3">
          <h4><center>Email Content</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Subject</td>
                <td className="col-6">
                  <input className="input-common"
                    value={subject} placeholder="Email Subject"
                    onChange={(event) => {
                      setSubject(event.target.value)
                      localStorage.setItem("EmailSubject", event.target.value)
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Email Content</td>
                <td className="col-6">
                  <textarea rows={7} className="input-common"
                    value={message} placeholder="Email Content"
                    onChange={(event) => {
                      setMessage(event.target.value)
                      localStorage.setItem("EmailMessage", event.target.value)
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Attachment</td>
                <td className="col-6">
                  <input
                    type="file"
                    // value={EmailContent} placeholder="Email Content"
                    onChange={e => setFile(e.target.files[0])}
                  // onChange={(event) => { setEmailContent(event.target.value) }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">

            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => { sendAll() }}
              >
                Send Email to All
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
